import { buildCandidateApplicationUrl } from "@workspace/dto/email/destinations";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import {
  defineEmailNotificationHandler,
  requireOrganizationId,
  resolveWorkplaceName,
} from "./types";

const ApplicationAcceptedSchema = z.object({
  applicationId: z.string(),
  jobId: z.string(),
  jobTitle: z.string(),
  companyName: z.string().optional(),
});

export const applicationAcceptedHandler = defineEmailNotificationHandler({
  type: "application.accepted",
  icon: "application",
  title() {
    return "Application accepted";
  },
  description(metadata) {
    const jobTitle =
      typeof metadata.jobTitle === "string" && metadata.jobTitle.trim()
        ? metadata.jobTitle
        : undefined;
    const companyName =
      typeof metadata.companyName === "string" && metadata.companyName.trim()
        ? metadata.companyName
        : undefined;
    return jobTitle
      ? `${companyName ?? "An employer"} accepted your application for ${jobTitle}.`
      : "An employer accepted your application.";
  },
  schema: ApplicationAcceptedSchema,
  buildNotificationPayload(data, _ctx) {
    return {
      metadata: {
        applicationId: data.applicationId,
        jobId: data.jobId,
        jobTitle: data.jobTitle,
        companyName: data.companyName,
      },
      links: {
        href: `/applications/${data.applicationId}`,
        label: "View application",
      },
    };
  },
  buildEmailPayload(
    data,
    recipient,
    { baseUrl, organizationId, unsubscribeUrl }
  ) {
    return {
      name: "email/application.accepted",
      data: {
        organizationId: requireOrganizationId({ organizationId }),
        to: recipient.email,
        from: buildFromAddress(),
        recipientName: recipient.name,
        workplaceName: resolveWorkplaceName(data.companyName),
        jobTitle: data.jobTitle,
        applicationUrl: buildCandidateApplicationUrl({
          applicationId: data.applicationId,
          baseUrl,
        }),
        unsubscribeUrl,
      },
    };
  },
});
